import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "メッセージ配信", -1)

import FormEdit from "./common/form.vue";
import { useStore } from "vuex";
import { onBeforeMount, ref } from "vue";
import { set } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

const store = useStore();

const channelId = ref<any>(0);

onBeforeMount(async () => {
  set(channelId, await store.dispatch("authClient/getChannelIdCookie"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(FormEdit, { channelId: channelId.value }, null, 8, ["channelId"])
  ]))
}
}

})